var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "house-component js-house-component" }, [
    _c(
      "div",
      { staticClass: "house-component-inner js-houses-component-eq-height" },
      [
        !_vm.isProjectClosed
          ? _c(
              "button",
              {
                staticClass: "btn btn--none house-component-remove",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    _vm.deleteHouse(_vm.house.id)
                  }
                }
              },
              [
                _c("span", {
                  staticClass:
                    "spinner spinner--black glyphicon glyphicon-remove"
                })
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("h3", { staticClass: "house-title" }, [
          !_vm.editingHouseName
            ? _c(
                "span",
                {
                  staticClass: "display-house-title",
                  class: { enabled: !_vm.isProjectClosed },
                  on: {
                    click: function($event) {
                      _vm.startEditName()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.name))]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editingHouseName,
                expression: "editingHouseName"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.name,
                expression: "name"
              }
            ],
            ref: "house-" + _vm.houseId,
            staticClass: "house-name-input",
            attrs: { type: "text", id: "house-" + _vm.houseId },
            domProps: { value: _vm.name },
            on: {
              keyup: function($event) {
                if (
                  !("button" in $event) &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                _vm.stopEditName()
              },
              blur: function($event) {
                _vm.stopEditName()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.name = $event.target.value
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.isCorona
          ? _c("div", { staticClass: "corona-attributes" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.coronaAttributes(_vm.house)) +
                  "\n        "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "house-component-inputs js-house-component-inputs" },
          [
            _c("div", { staticClass: "js-floors-input" }, [
              _c("div", { staticClass: "integer-input" }, [
                _c(
                  "label",
                  { staticClass: "control-label integer-input-label" },
                  [_vm._v("Våningar")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--round",
                    attrs: {
                      type: "button",
                      disabled: !_vm.isFloorDecreasable || _vm.isProjectClosed
                    },
                    on: {
                      click: function($event) {
                        _vm.decreaseFloor()
                      }
                    }
                  },
                  [_c("span", { staticClass: "glyphicon glyphicon-minus" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "integer-input-value" }, [
                  _vm._v(_vm._s(_vm.house.floors) + " ")
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--round",
                    attrs: {
                      type: "button",
                      disabled: !_vm.isFloorIncreasable || _vm.isProjectClosed
                    },
                    on: {
                      click: function($event) {
                        _vm.increaseFloor()
                      }
                    }
                  },
                  [_c("span", { staticClass: "glyphicon glyphicon-plus" })]
                )
              ])
            ]),
            _vm._v(" "),
            _vm._l(_vm.house.apartments, function(apartment) {
              return _c("house-apartment", {
                key: apartment.id,
                attrs: {
                  apartmentId: apartment.id,
                  houseId: _vm.house.id,
                  apartmentSizeDict: _vm.apartmentSizes,
                  debounceSave: _vm.debounceSave
                }
              })
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{}!./~/vue-loader/lib?{}!./assets/vue/houseModel/components/house.vue?vue&type=template&id=c127e074&
// module id = 498
// module chunks = 0